import { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import { apiFileDestList, apiSaveLog } from 'api/api'

import NavigateButton from 'components/NavigateButton'

import SpeedImg from 'assets/img/speed/speed.png'
import Bg from 'assets/img/cps/tracknfield2.png'
// import Bg2 from 'assets/img/cps/bgList1.png'
import Bg2 from 'assets/img/screenType1/viewBg2.png'
import SizeSoldoutImg from 'assets/img/common/sizeSoldOut.png'
import SoldOutImg from 'assets/img/common/soldOut.png'

import Slider, { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ArrowLeft from 'assets/img/main/arrowLeft.svg'
import ArrowRight from 'assets/img/main/arrowRight.svg'

import ExclusiveLogo from 'assets/img/sps/exclusive.svg'
import HeritageLogo from 'assets/img/sps/heritage.svg'
import TrailLogo from 'assets/img/sps/trail.svg'

import IndexImage from 'assets/img/cps/index.png'
import OtherColor from 'assets/img/cps/othercolor.png'
import {
	OtherColorSlider,
	viewPageSliderSettings,
} from 'components/StyleComponents'
import { NewIconImg } from 'components/StyleComponents'

const SizeSoldOut = styled.div`
	position: absolute;
	top: 0;
	left: 0;
`

const Container = styled.div`
	background-image: url(${Bg2});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`

const MainSubImg = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 900px;
	height: 740px;
	display: flex;
	justify-content: center;
	align-items: center;
	img {
		max-width: 100%;
		max-height: 100%;
	}
`

const SlideContainer = styled.section`
	position: absolute;
	top: 0;
	left: 0;
	width: 1130px;
	height: 1080px;
	background-color: #212322;
	overflow: hidden;
	.imgContainer {
		img {
			display: block;
			margin: 0 auto;
		}
	}
`

const NextArrowContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 50px;
	width: 43px;
	height: 85px;
	z-index: 1;
	&::before {
		content: url(${ArrowRight});
		width: 43px;
		height: 85px;
	}
`
const PrevArrowContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 50px;
	width: 43px;
	height: 85px;
	z-index: 1;
	&::before {
		content: url(${ArrowLeft});
		width: 43px;
		height: 85px;
	}
`

const DiffItems = styled.div``

const PageTitle = styled.div`
	position: absolute;
	top: 68px;
	left: 58px;
	font-size: 40px;
	color: #2f302f;
	width: 250px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 100%;
		height: 10px;
		background: #515151;
		margin: 15px 0;
	}
	span {
		font-size: 50px;
	}
`

const CpsView = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()
	const videoRef = useRef<HTMLVideoElement>(null)
	const reviewVideoRef = useRef<HTMLVideoElement>(null)

	const [popupOpen, setPopupOpen] = useState<boolean>(false)
	const [popupType, setPopupType] = useState<string>('') // color, gallery, video
	const [colorPopupImage, setColorPopupImage] = useState<number>(0)

	const [activeTabNumber, setActiveTabNumber] = useState<number>(0)

	const [colorsList, setColorsList] = useState([])
	const [defaultImageFileId, setDefaultImageFileId] = useState<number>(0)
	const [keyVisualImageFileId, setKeyVisualImageFileId] = useState<number>(0)
	const [lookList, setLookList] = useState([])
	const [otherList, setOtherList] = useState([])
	const [techFileId, setTechFileId] = useState<number>(0)
	const [videoList, setVideoList] = useState<string[]>([])
	const [videoReview, setVideoReview] = useState<string>('')
	const [keyVisualList, setKeyVisualList] = useState<string[]>([])

	const currentVideoIndex = useRef(0)

	const [itemName, setItemName] = useState('')
	const [logoTitle, setLogoTitle] = useState('')

	const menuMove1 = useSpring({
		from: { opacity: 0, x: 100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const titleMove = useSpring({
		from: { opacity: 0, y: -100 },
		to: { opacity: 1, y: 0 },
		delay: 0,
	})

	const menuMove3 = useSpring({
		from: { opacity: 0 },
		to: { opacity: 1 },
		delay: 0,
	})

	const onTouchEnd = (e: any) => {
		console.log(e)
	}

	const [cpsItemInfo, setCpsItemInfo] = useState<any>(null)

	const colorAction = (e: any) => {
		setPopupType('color')
		setColorPopupImage(e.subId)
		setCpsItemInfo(e)
		setPopupOpen(true)

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: e.productId,
			subSortId: location.state?.item?.subsortId,
			subId: e.subId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId &&
			logRequest.subId
		) {
			apiSaveLog(logRequest)
		}
	}

	const popupAction = (e: any) => {
		if (videoRef.current) {
			currentVideoIndex.current = 0
			videoRef.current.pause()
		}
		if (reviewVideoRef.current) {
			reviewVideoRef.current.pause()
		}
		if (e === 'tech') {
			setPopupType('tech')
			setActiveTabNumber(1)
		} else if (e === 'video') {
			setPopupType('video')
			setActiveTabNumber(2)
			playVideo()
		} else if (e === 'look') {
			setPopupType('look')
			setActiveTabNumber(3)
		} else if (e === 'review') {
			setPopupType('review')
			setActiveTabNumber(4)
			playReviewVideo()
		}
		setPopupOpen(true)
	}

	const closePopup = () => {
		setPopupOpen(false)
		setActiveTabNumber(0)
		setColorPopupImage(0)
		setCpsItemInfo(null)
		setPopupType('')
		if (videoRef.current) {
			currentVideoIndex.current = 0
			videoRef.current.pause()
		}
		if (reviewVideoRef.current) {
			reviewVideoRef.current.pause()
		}
	}

	const NextArrow = (props: any) => {
		const { className, style, onClick } = props
		return (
			<NextArrowContainer
				className={className}
				style={{ ...style }}
				onClick={onClick}
			/>
		)
	}

	const PrevArrow = (props: any) => {
		const { className, style, onClick } = props
		return (
			<PrevArrowContainer
				className={className}
				style={{ ...style }}
				onClick={onClick}
			/>
		)
	}

	const handleVideoEnd = () => {
		currentVideoIndex.current++
		if (currentVideoIndex.current >= videoList.length) {
			currentVideoIndex.current = 0
		}
		playVideo()
	}

	const playVideo = () => {
		const video = videoRef.current
		if (video) {
			setTimeout(() => {
				video.src = videoList[currentVideoIndex.current]
				video.load()
				video.play()
			}, 400)
		}
	}

	const handleReviewViewEnd = () => {
		playVideo()
	}

	const playReviewVideo = () => {
		const video = reviewVideoRef.current
		console.log(video)
		console.log(videoRef.current)
		if (video) {
			setTimeout(() => {
				video.src = videoReview
				video.load()
				video.play()
			}, 400)
		}
	}

	const settings: Settings = {
		dots: false,
		infinite: true,
		arrows: true,
		speed: 300,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
	}

	const [isDragging, setIsDragging] = useState(false)

	const handleTouchStart = () => {
		setIsDragging(false)
	}

	const handleTouchMove = () => {
		setIsDragging(true)
	}

	const handleTouchEnd = (index: number) => {
		if (!isDragging) {
			// pageMove(menuList[index])
			colorAction(otherList[index])
		}
		setIsDragging(false)
	}

	useEffect(() => {
		console.log(location.state)
		setLogoTitle(location.state?.item?.title)
		setItemName(location.state?.item?.name)
		if (location.state?.item?.subsortId) {
			const request = {
				subsortId: location.state?.item?.subsortId,
				kioskDeviceId: deviceInfo.kioskDeviceId,
				userId: deviceInfo.userId,
				productId: location.state?.item?.productId,
			}
			apiFileDestList(request).then((res) => {
				console.log(res)
				setColorsList(res.colors)
				setDefaultImageFileId(res.defaultImage?.fileId)
				setKeyVisualImageFileId(res.keyVisualImage?.fileId)
				setLookList(res.look)
				setOtherList(res.other)
				if (res.video.length > 0) {
					const fileNameList: string[] = []
					res.video.forEach((item: any) => {
						fileNameList.push(
							`${process.env.REACT_APP_HOST}/video/view/${item.fileName}`,
						)
					})
					setVideoList(fileNameList)
				}
				setTechFileId(res.tech?.fileId)
				if (res.videoReview?.fileName) {
					setVideoReview(
						`${process.env.REACT_APP_HOST}/video/view/${res.videoReview?.fileName}`,
					)
				}
				setKeyVisualList(res.keyVisual)
				setItemName(location.state?.item?.name)
			})
		}
		if (!location.state?.item) {
			timerAlert('잘못된 접근입니다.', 'error', () => navigate('/'))
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<>
			<div className={popupOpen ? 'popupContainer active' : 'popupContainer'}>
				<button
					type="button"
					className="btnPopupClose"
					onClick={closePopup}
				></button>
				{popupType === 'color' && (
					<div className="colorContainer">
						{colorPopupImage && (
							<div style={{ position: 'relative' }}>
								<img
									src={`${process.env.REACT_APP_HOST}/file/sub/view/file?subId=${colorPopupImage}&type=`}
									alt=""
								/>
								<div style={{ position: 'absolute', top: 730, left: 50 }}>
									{cpsItemInfo.prdNo && (
										<p>
											{cpsItemInfo.prdNo} / {cpsItemInfo.color}
										</p>
									)}
								</div>
							</div>
						)}
					</div>
				)}
				{popupType === 'tech' && (
					<div className="colorContainer">
						<img
							src={`${process.env.REACT_APP_HOST}/file/view/id/${techFileId}`}
							alt=""
						/>
					</div>
				)}
				<div
					className="videoContainer"
					style={{
						display: popupType === 'video' && videoList.length > 0 ? 'block' : 'none',
					}}
				>
					<video
						className="video"
						ref={videoRef}
						onEnded={handleVideoEnd}
					>
						<source
							src={`${videoList[currentVideoIndex.current]}`}
							type="video/mp4"
						/>
					</video>
				</div>
				{popupType === 'review' ? (
					<div
						className="videoContainer"
						style={{
							display: popupType === 'review' && videoReview ? 'block' : 'none',
						}}
					>
						<video
							className="video"
							ref={reviewVideoRef}
							onEnded={handleReviewViewEnd}
							autoPlay
						>
							<source
								src={videoReview || ''}
								type="video/mp4"
							/>
						</video>
					</div>
				) : null}
				{popupType === 'look' && lookList.length > 0 ? (
					<div className="slideContainer">
						<Slider {...settings}>
							{lookList.map((item: any, index: number) => {
								return (
									<li key={item.fileId}>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt=""
										/>
									</li>
								)
							})}
						</Slider>
					</div>
				) : null}
			</div>
			<Container className="container">
				{/* <PageTitle>
					<animated.div style={titleMove}>
						<span className="asics-bold-italic">TENNIS</span>
					</animated.div>
				</PageTitle> */}
				<animated.div style={titleMove}>
					<div className="pageTitle2">
						<b>
							{location.state?.item?.subPageTItle === '배구'
								? 'VOLLEYBALL'
								: location.state?.item?.subPageTItle === '테니스'
									? 'TENNIS'
									: location.state?.item?.subPageTItle === '트랙엔필드'
										? 'TRACK & FIELD'
										: ''}
						</b>
						<p>
							{/* {location.state?.item?.subPageTItle === '배구'
								? 'SPEED'
								: location.state?.item?.subPageTItle === '테니스'
								? 'Stability & Speed'
								: location.state?.item?.subPageTItle === '트랙엔필드'
								? 'Middle Distance'
								: ''} */}
							{/* {location.state?.item?.pageTitle} */}
							{location.state?.item?.subTitlte}
						</p>
					</div>
				</animated.div>
				<MainSubImg>
					{defaultImageFileId > 0 && (
						<img
							src={`${process.env.REACT_APP_HOST}/file/view/id/${defaultImageFileId}`}
							alt=""
							className="mainSub"
						/>
					)}
				</MainSubImg>
				<animated.div style={menuMove1}>
					<ul className="sideNav2">
						{techFileId > 0 ? (
							<li className={activeTabNumber === 1 ? 'active' : ''}>
								<button
									type="button"
									onClick={() => popupAction('tech')}
									className="techBtn"
								>
									<span className="tech">F</span>
									<span className="tech">u</span>
									<span className="tech">n</span>
									<span className="tech">c</span>
									<span className="tech">t</span>
									<span className="tech">i</span>
									<span className="tech">o</span>
									<span className="tech">n</span>
								</button>
							</li>
						) : null}
						{videoList.length > 0 && (
							<li className={activeTabNumber === 2 ? 'active' : ''}>
								<button
									type="button"
									onClick={() => popupAction('video')}
								>
									<span>Video</span>
								</button>
							</li>
						)}
						{lookList.length > 0 && (
							<li className={activeTabNumber === 3 ? 'active' : ''}>
								<button
									type="button"
									onClick={() => popupAction('look')}
								>
									<span>Images</span>
								</button>
							</li>
						)}
						{videoReview ? (
							<li className={activeTabNumber === 4 ? 'active' : ''}>
								<button
									type="button"
									onClick={() => popupAction('review')}
								>
									<span>Review</span>
								</button>
							</li>
						) : null}
					</ul>
				</animated.div>
				<OtherColorSlider
					style={{
						position: 'absolute',
						bottom: 0,
						right: 66,
						left: 1100,
						width: 'auto',
						height: 320,
						paddingTop: 75,
						// '& .indexImage': {
						// 	position: 'absolute',
						// 	bottom: 42,
						// 	right: 20,
						// 	display: 'block',
						// },
						// '& .otherColor': {
						// 	position: 'absolute',
						// 	bottom: 268,
						// 	right: -40,
						// },
					}}
				>
					<animated.div style={menuMove3}>
						<div className="diffItems">
							{otherList.length > 0 ? (
								<div
									className="diffRow"
									style={{ height: 150, overflow: 'hidden' }}
								>
									<div className="horizontalScrollerContainer">
										{otherList.map((item: any, index: number) => (
											<li key={item.subId}>
												{item.subId && (
													<button
														type="button"
														// onClick={() => colorAction(item)}
														onTouchStart={handleTouchStart}
														onTouchMove={handleTouchMove}
														onTouchEnd={() => handleTouchEnd(index)}
														onMouseDown={handleTouchStart}
														onMouseMove={handleTouchMove}
														onMouseUp={() => handleTouchEnd(index)}
													>
														<img
															src={`${process.env.REACT_APP_HOST}/file/sub/view/file?subId=${item.subId}&type=thumb`}
															alt=""
															style={{
																maxWidth: 145,
															}}
														/>
														{item.isSoldout && (
															<div className="soldOut">
																<img
																	src={SoldOutImg}
																	alt="전체 제고 없음"
																/>
															</div>
														)}
														{item.isSizeSoldout && (
															<div className="sizeSoldOut">
																<img
																	src={SizeSoldoutImg}
																	alt="사이즈 제고 없음"
																/>
															</div>
														)}
														{item.newTag && <NewIconImg />}
													</button>
												)}
											</li>
										))}
									</div>
								</div>
							) : (
								<div className="noList">제품이 없습니다.</div>
							)}
						</div>
					</animated.div>
					<img
						src={OtherColor}
						className="otherColor"
						alt=""
						style={{ left: 'auto' }}
					/>
					<img
						src={IndexImage}
						alt=""
						className="indexImage"
					/>
				</OtherColorSlider>
				{keyVisualList.length > 0 && (
					<div className="keyVisualLeftContainer">
						<Slider {...settings}>
							{keyVisualList.map((item: any, index: number) => {
								return (
									<li key={item.fileId}>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt=""
										/>
									</li>
								)
							})}
						</Slider>
					</div>
				)}
				<NavigateButton />
			</Container>
		</>
	)
}

export default CpsView
